import React from 'react';
import { PlayerBarBottomWrapper } from './PlayerBarBottomPrimitives';

export interface PlayerBarBottomProps {
  minimized: boolean;
  mirrored: boolean;
  centered?: boolean;
}

export const PlayerBarBottom: React.FC<React.PropsWithChildren<PlayerBarBottomProps>> = ({
  minimized,
  mirrored,
  centered,
  children,
}) => {
  return (
    <PlayerBarBottomWrapper minimized={minimized} mirrored={mirrored} centered={!!centered}>
      {children}
    </PlayerBarBottomWrapper>
  );
};
